import {SxProps} from '@mui/material';

export const filtersModalStyles: Record<string, SxProps> = {
	modalContainer: {bgcolor: 'white', mt: '40px', borderRadius: 2, width: '100%'},
	columnsWrapper: {display: 'flex', justifyContent: 'space-between', gap: '34px', pl: '17px'},
	leftColumn: {
		width: '270px',
	},
	rightColumn: {
		width: '49%',
	},
	columnItem: {
		display: 'flex',
		justifyContent: 'space-between',
		maxWidth: '270px',
	},
	columnItemRight: {
		display: 'flex',
		justifyContent: 'space-between',
		maxWidth: '271px',
	},
	checkboxLabel: {
		height: '40px',
	},
	checkboxLabelRight: {
		gap: 1.5,
		height: '40px',
	},
	actionsContainer: {
		width: '100%',
	},
};
